import { Backdrop } from "components";
import { FiLoader } from "react-icons/fi";
import { Button, Card, CardBody, CardText } from "reactstrap";

const CustomAlert = ({
    show,
    hideModal,
    title,
    description = "",
    submitButtonText,
    submitModal,
    body = "",
    fitToParent = false,
    width,
    disabled = false,
    waiting = Promise.resolve(true)
}) => {
    return (
        <Backdrop open={show} hide={hideModal} fitToParent={fitToParent}>
            <Card
                style={{
                    width: width ? width : "25rem",
                    maxWidth: "95vw",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }}
                onClick={e => e.stopPropagation()}
                className="py-2 text-center"
            >
                <CardBody>
                    <div className="text-danger font-weight-bold display-5 mb-2">{title}</div>
                    <div className="mb-4 mt-3">{body}</div>
                    {description && <CardText className="mb-4">{description}</CardText>}
                    <div className="d-flex justify-content-center">
                        <Button
                            onClick={() => Promise.resolve(submitModal())}
                            color="danger"
                            type="button"
                            disabled={disabled}
                        >
                            {disabled ? <FiLoader size={20} className="animate-spin" /> : submitButtonText}
                        </Button>
                        <Button onClick={hideModal} color="secondary" type="button">
                            Cancel
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </Backdrop>
    );
};

export default CustomAlert;
